import React, { useEffect, useState, useMemo } from 'react';
import cx from 'classnames';
import TargetRenterSelect from '../../DropDownContents/TargetRenterSelect';
import { change, Field, getFormValues, formValueSelector, reduxForm } from 'redux-form';
import CustomCheckbox from '../../../CustomCheckbox/CustomCheckbox';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { closeAIModal } from '../../../../actions/modalActions';
import messages from '../../../../locale/jsonMessages';
import Loader from '../../../Loader/Loader';
import CopyTextBlock from '../../CopyTextBlock/CopyTextBlock';
import {
    buildPreferences,
    getLocation,
    getSelectedCarFeatures,
    getSelectedMakeAndModal
} from '../../Helper/getListingData';
import submit from './submit';
import { AIIcon } from '../../../Common/Assets/SvgIconComponent/CommonSvgIcon';

import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles';
import { AI_BUTTON_LOADER } from '../../../../constants';

import cs from '../../../../components/commonStyle.css';
import s from '../../AIFeatureStyle.css';



function ListingTitleDescriptionForm({ handleSubmit, currentAIIndex }) {

    const { formatMessage } = useIntl();
    const dispatch = useDispatch();

    const [showGenerate, setShowGenerate] = useState(true);
    const [showReGenerate, setShowReGenerate] = useState(false);
    const [messagesCache, setMessagesCache] = useState({});
    const [isCopied, setIsCopied] = useState({ title: false, description: false });

    const [location, setLocation] = useState(null);
    const [carFeatures, setCarFeatures] = useState(null);
    const [getMake, setGetMake] = useState(null);
    const [getModel, setGetModel] = useState(null);
    const [getCarType, setGetCarType] = useState(null);
    const [odometer, setOdometerFeatures] = useState(null);
    const [year, setYear] = useState(null);
    const [transmission, setTransmission] = useState(null);

    const aiResponseContent = useSelector(state => state?.aiContents?.carTitleDescription);
    const aiDataLoader = useSelector(state => state?.aiContents?.aiResponseLoading);
    const data = useSelector((state) => state?.listingFields?.data) || {};
    const selector = formValueSelector('ListingTitleDescriptionForm');
    const formValues = useSelector((state) => getFormValues('ListPlaceStep1')(state)) || {};

    useEffect(() => {

        const loadData = async () => {
            setLocation(getLocation(formValues));
            setCarFeatures(await getSelectedCarFeatures(
                formValues?.carFeatures,
                data?.carFeatures
            ));
            setGetMake(await getSelectedMakeAndModal(formValues?.make, data?.make));
            setGetModel(await getSelectedMakeAndModal(formValues?.model, data?.model));
            setGetCarType(await getSelectedMakeAndModal(formValues?.carType, data?.carType));
            setOdometerFeatures(await getSelectedMakeAndModal(formValues?.odometer, data?.odometer))
            setYear(await getSelectedMakeAndModal(formValues?.year, data?.year))
            setTransmission(formValues?.transmission == 1 ? 'Automatic' : 'Manual')
        };
        loadData();
    }, [formValues]);

    const handleRegenerate = async (values) => {
        await handleSubmit(submit)(values);
        setShowGenerate(false);
        setShowReGenerate(true);
    };


    const isTitleChanged = useSelector(state => selector(state, 'isTitleChanged'));
    const isDescriptionChanged = useSelector(state => selector(state, 'isDescriptionChanged'));

    const carDetails = [
        getCarType,
        getMake,
        getModel,
        year,
        transmission,
        odometer
    ].filter(Boolean).join(", ");

    const preferences = useMemo(() => {
        return buildPreferences({
            formatMessage,
            location,
            carFeatures,
            carDetails,
            messages
        });
    }, [location, carFeatures, carDetails, messages]);

    useEffect(() => {
        if (aiResponseContent && Object.keys(aiResponseContent).length > 0) {
            setMessagesCache(aiResponseContent);
        }
        if (aiDataLoader && !showReGenerate) {
            setMessagesCache({});
        }
    }, [aiResponseContent, aiDataLoader, showReGenerate]);

    const handleGenerate = async (values) => {
        await handleSubmit(submit)(values);
        setShowGenerate(false);
    };


    const handleCopy = (type) => {
        const textToCopy =
            type === 'title' ? messagesCache?.title : messagesCache?.description;

        if (!textToCopy) return;

        navigator.clipboard.writeText(textToCopy);
        setIsCopied(prev => ({ ...prev, [type]: true }));

        setTimeout(() => {
            setIsCopied(prev => ({ ...prev, [type]: false }));
        }, 1000);
    };

    const handleCancel = () => {
        dispatch(closeAIModal());
        setShowReGenerate(false);
    };

    const handleApply = () => {
        if (isTitleChanged) {
            dispatch(change('ListPlaceStep2', `dynamicListTitleDescription[${currentAIIndex}].listTitle`, messagesCache?.title));
        }
        if (isDescriptionChanged) {
            dispatch(change('ListPlaceStep2', `dynamicListTitleDescription[${currentAIIndex}].listDescription`, messagesCache?.description));
        }
        dispatch(closeAIModal());
        setShowReGenerate(false);
    };


    const renderCheckboxGroup = ({ input, meta: { touched, error }, options }) => {
        const currentValue = input.value || [];

        const handleChange = (checked, option) => {
            const newValue = checked
                ? [...currentValue, { id: option.id, value: option.value }]
                : currentValue.filter((item) => item.id !== option.id);

            input.onChange(newValue);
        };

        return (
            <div>
                {touched && error && <span className="errorMessageText">{formatMessage(error)}</span>}
                <div className="oneColumnGrid">
                    {options.map((option) => {
                        const isChecked = currentValue.some((item) => item.id === option.id);

                        return (
                            <div key={option.id}>
                                <CustomCheckbox
                                    className="commonCustomCheckBox normalSizeCheckBox"
                                    containerClassName='commonCustomCheckFlex'
                                    label={
                                        <span>
                                            <span className={cs.fontWeightBold} >{option.label}</span>&nbsp;
                                            {option.labelValue}
                                        </span>
                                    }
                                    checked={isChecked}
                                    onChange={(checked) => handleChange(checked, option)}
                                    disabled={option.disabled}
                                    labelClassName={cs.commonSmallText14}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div>
            <div className='oneColumnGrid'>
                <TargetRenterSelect />

                <label className='commonLabelText'>
                    <FormattedMessage {...messages.selectLabel} />
                </label>
                <Field
                    name="preferences"
                    component={renderCheckboxGroup}
                    options={preferences}
                />

                {!showGenerate && !aiDataLoader && (
                    <div className={s.aiGenerateInputWrapper}>
                        <div className={s.aiGenerateBoxLine}>
                            <div className={s.aiGenerateTextBox}>
                                <CopyTextBlock
                                    label={formatMessage(messages.titleLabel)}
                                    content={messagesCache?.title}
                                    isCopied={isCopied.title}
                                    onCopy={() => handleCopy('title')}
                                    copiedLabel={formatMessage(messages.copiedLabel)}
                                    containerClass={cs.spaceBottom3}
                                    isCheckBox
                                    name="isTitleChanged"
                                />
                                <CopyTextBlock
                                    label={formatMessage(messages.aboutCar)}
                                    content={messagesCache?.description}
                                    isCopied={isCopied.description}
                                    onCopy={() => handleCopy('description')}
                                    copiedLabel={formatMessage(messages.copiedLabel)}
                                    isCheckBox
                                    name="isDescriptionChanged"
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <div className={cx(cs.displayFlex, cs.alignCenter, cs.spaceBetween, cs.gap12, cs.flexWrap, cs.spaceTop4, cs.mobileAlignFlexStretch, cs.mobileFlexColumn)}>
                <div className={cx(cs.displayFlex, cs.gap12, cs.justifyContentSpaceBetween, cs.alignCenter, cs.flexWrap, cs.flexGrow)}>
                    {(!showGenerate && messagesCache && Object.keys(messagesCache).length > 0) &&
                        <Loader
                            type="button"
                            handleClick={handleRegenerate}
                            className={cs.regenerateBtn}
                            label={<>
                                <AIIcon />
                                <span className={cs.aiTextColor}>{formatMessage(messages.reGenerateLabel)}</span>
                            </>}
                            show={aiDataLoader}
                            spinnerColor={AI_BUTTON_LOADER}
                        />
                    }


                    <div className={cx('doubleBtnFlexEnd', cs.flexGrow)}>
                        <Button onClick={handleCancel} className={cs.btnPrimaryBorder}>
                            <FormattedMessage {...messages.deSelect} />
                        </Button>

                        {aiDataLoader && (messagesCache && Object.keys(messagesCache).length == 0) && !showReGenerate ?
                            <Loader
                                type="button"
                                handleClick={handleGenerate}
                                label={formatMessage(messages.generateLabel)}
                                show={aiDataLoader}
                                className={cx(cs.btnPrimary, cs.btnLarge, 'loaderButtonFlex')}
                            />
                            :
                            showGenerate &&
                            <Button type="button" onClick={handleGenerate} className={cx(cs.btnPrimary, cs.btnLarge)}>
                                <FormattedMessage {...messages.generateLabel} />
                            </Button>
                        }
                    </div>
                </div>

                {(!showGenerate && messagesCache && Object.keys(messagesCache).length > 0) &&
                    <Button onClick={handleApply} className={cs.btnPrimary} disabled={!isTitleChanged && !isDescriptionChanged}>
                        <FormattedMessage {...messages.apply} />
                    </Button>
                }
            </div>
        </div>
    );
};

ListingTitleDescriptionForm = reduxForm({
    form: 'ListingTitleDescriptionForm'
})(ListingTitleDescriptionForm);

export default compose(withStyles(cs, s)(ListingTitleDescriptionForm));